import { useEffect, useState } from "react";
import api, { BASE_URL } from "../services/api";
import Navbar from "../components/Navbar";

function BarcodeSummary() {

    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState("");

    const loadData = async () => {

        try {

            const res = await api.get(
                "/barcodes/summary"
            );

            setData(res.data.data);

        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const deleteBatch = async (itemName) => {

        const confirmDelete =
            window.confirm(
                `Delete all coupons for ${itemName}?`
            );

        if (!confirmDelete) return;

        try {

            await api.post(
                "/barcodes/delete",
                { itemName }
            );

            alert("Deleted Successfully");

            loadData();

        } catch (error) {

            alert(
                error.response?.data?.message
            );
        }
    };
    const downloadPdf = async (itemName) => {

        try {

            const res = await api.post(
                "/barcodes/generate-pdf",
                {
                    itemName
                }
            );

            window.open(
                `${BASE_URL}/api${res.data.url}`,
                "_blank"
            );

        } catch (error) {

            alert(
                error.response?.data?.message ||
                "Error generating PDF"
            );
        }
    };

    const viewBarcodes = async (itemName) => {
        try {
            const res = await api.get(`/barcodes/item/${itemName}`);
            setViewData(res.data.data);
            setSelectedItem(itemName);
            setShowModal(true);
        } catch (error) {
            alert("Error fetching barcodes");
        }
    };

    const scannedCount = viewData.filter(bc => bc.status === 'ON').length;
    const pendingCount = viewData.length - scannedCount;

    return (
        <>

            <Navbar />
            <div className="container mt-4">

                <h3>Barcode Summary</h3>

                <table className="table table-bordered table-striped">

                    <thead>

                        <tr>
                            <th>ID</th>
                            <th>Item Name</th>
                            <th>Qty</th>
                            <th>Created Date</th>
                            <th>Actions</th>
                        </tr>

                    </thead>

                    <tbody>

                        {
                            data.map((row, index) => (

                                <tr key={index}>

                                    <td>{row.batch_id}</td>

                                    <td>{row.item_name}</td>

                                    <td>{row.qty}</td>

                                    <td>
                                        {
                                            new Date(
                                                row.created_at
                                            ).toLocaleDateString()
                                        }
                                    </td>

                                    <td>

                                        <button
                                            className="btn btn-info btn-sm me-2 text-white"
                                            onClick={() =>
                                                viewBarcodes(
                                                    row.item_name
                                                )
                                            }
                                        >
                                            View
                                        </button>

                                        <button
                                            className="btn btn-primary btn-sm me-2"
                                            onClick={() =>
                                                downloadPdf(
                                                    row.item_name
                                                )
                                            }
                                        >
                                            PDF
                                        </button>

                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() =>
                                                deleteBatch(
                                                    row.item_name
                                                )
                                            }
                                        >
                                            Delete
                                        </button>

                                    </td>

                                </tr>

                            ))
                        }

                    </tbody>

                </table>

            </div>

            {showModal && (
                <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)", overflowY: "auto" }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Barcodes for {selectedItem}</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex justify-content-around mb-3 border-bottom pb-2">
                                    <h6 className="text-success fw-bold">Scanned: {scannedCount}</h6>
                                    <h6 className="text-secondary fw-bold">Not Scanned: {pendingCount}</h6>
                                    <h6 className="text-primary fw-bold">Total: {viewData.length}</h6>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover table-sm">
                                        <thead className="table-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Barcode</th>
                                                <th>Status</th>
                                                <th>Scanned By</th>
                                                <th>Scanned At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {viewData.map((bc, idx) => {
                                                const isScanned = bc.status === 'ON';
                                                return (
                                                    <tr key={idx}>
                                                        <td className={isScanned ? "text-success fw-bold" : ""}>{idx + 1}</td>
                                                        <td className={isScanned ? "text-success fw-bold" : ""}>{bc.barcode_value}</td>
                                                        <td className={isScanned ? "text-success fw-bold" : ""}>
                                                            {isScanned ? "Scanned" : "Pending"}
                                                        </td>
                                                        <td className={isScanned ? "text-success fw-bold" : ""}>
                                                            {bc.scanned_by || "-"}
                                                        </td>
                                                        <td className={isScanned ? "text-success fw-bold" : ""}>
                                                            {bc.scanned_at ? new Date(bc.scanned_at).toLocaleString() : "-"}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
}

export default BarcodeSummary;